








































































































































import { cloneDeep } from 'lodash'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import { successNotificationWrapper } from "../../../logic/helpers/NotificationService";
import CurrenciesHelperMixin from "../CurrenciesHelperMixin";
import CashRegisterSetup from "./CashRegisterSetup.vue";
import CashRegistersCore from './index'

@Component({
  components: {
    CashRegisterSetup,
  },
  methods: {
    cloneDeep
  }
})
export default class CashRegisters extends Mixins(CurrenciesHelperMixin) {
  @Prop() core!: CashRegistersCore

  editableCash: number | null = null

  archiveIsOpen = false

  isLoading = false

  isCashRegisterModalOpen = false

  removePaymentSystem(id: number): void {
    this.$confirm({
      title: this.$t('delete').toString(),
      content: this.$t('shop_remove_cash_register_alert_text').toString(),
      okText: this.$t('accept').toString(),
      okType: 'danger',
      cancelText: this.$t('reject').toString(),
      centered: true,
      onOk: () => {
        this.isLoading = true

        this.core.deleteCashRegistersHandler(id)
          .then(res => {
            if (res) {
              successNotificationWrapper(this.$t('success').toString(), '')
            }
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    })
  }
}
